/**
 * Filter streaming events by a case-insensitive search query.
 *
 * Events are matched against their `title`, `description`, and `time`
 * fields (whichever are present). An empty/whitespace-only query
 * returns the original list unchanged.
 *
 * @param {Array<object>} events - List of streaming event objects.
 * @param {string} query - The search query to filter by.
 * @returns {Array<object>} The events that match the query.
 */
export function filterEvents(events, query) {
    const trimmed = (query || '').trim().toLowerCase();

    if (!trimmed) {
        return events;
    }

    return events.filter((event) => {
        const haystack = [event.title, event.description, event.time]
            .filter(Boolean)
            .join(' ')
            .toLowerCase();

        return haystack.includes(trimmed);
    });
}

export default filterEvents;
